
import React, { useEffect } from "react";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from "react-router-dom";
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getPatientListData } from "../../service/api.service";
import { EventEmitter } from "../../event";
import { clearLocalStrorage } from "../common/codeHelper";
import { withRouter } from "../common/withRouter";

// class PatientList extends React.Component {
let rowsValue = [];
function PatientList(props) {
    // navigate = useNavigate();
    const navigate = useNavigate();
    let columns = [
        { id: 'name', label: 'Patient\u00a0Name', minWidth: 170 },
        { id: 'mrn', label: 'MR\u00a0Number', minWidth: 100 },
        {
            id: 'description',
            label: 'Description',
            minWidth: 170,
            align: 'center',
            format: (value) => value.toLocaleString('en-US'),
        },
        { id: 'btn', label: '', minWidth: 100, align: 'center', }
    ];


 
    let state = {
        id: '',
        page: 0,
        rowsPerPage: 10,
    }
    const [rows, setRows] = React.useState(rowsValue);
    const [searched, setSearched] = React.useState('');
    const [page, setPage] = React.useState({ page: state.page, rowsPerPage: state.rowsPerPage });

    useEffect(() => { 
        if(!rows.length)
            getData()
    }) 

    const handleChangePage = (event, newPage) => {

        setPage({ page: newPage, rowsPerPage: page.rowsPerPage })
    };



    function getData() {
        rowsValue = []
        getPatientListData(data => {
            if (data) {
                if (data.error) {
                    if (data.type === 'REDIRECTLOGIN') {

                        EventEmitter.dispatch("loginChanged", "false"); 
                        clearLocalStrorage();
                        navigate('./Login', { replace: true });
                    }
                } else { 
                    data.forEach(element => {
                        const detail = element.pateintDetails;
                        rowsValue.push(createData(detail.name, '-', '-', "View"));
                    });
                     setRows(rowsValue) 
                }

            }
        })
    }

    const handleChangeRowsPerPage = (event) => {
        setPage({ page: 0, rowsPerPage: event.target.value });
    };
    function createData(name, mrn, description, btn) {
        return { name, mrn, description, btn };
    }
    function handleClick(id) {
    }

    const requestSearch = (searchedVal) => {
        setSearched(searchedVal.target.value)
        const filteredRows = rowsValue.filter((row) => {
            return row.name.includes(searchedVal.target.value);
        }); 
        setRows(filteredRows); 
    };

    const goto = (row)=>{ 
        props.navigate("/ViewerTabs", {
            state: {
                "id": row
            },
        });
    }


    return (
        <Paper sx={{ width: '100%',  overflow: 'hidden', backgroundColor:'rgba(255,255,255,0.8)', }} className="animate__animated animate__fadeInDown  ">
            <div className="flex pb-1 border-b border-grey-400 animate__animated animate__rotateInDownLeft ">
                <div className="w-1/2 text-lg font-semibold ">
                    <div className="px-4 pt-3 text-blue-900"> <img src={require('../../assets/images/petient-list-icon.png')} alt="" className="mr-1 inline-block w-6" /> Patient List</div>
                </div>
                <div className="w-1/2 search-col px-4">
                    <Paper
                        component="form"
                        className="m-2"
                        sx={{ display: 'flex', alignItems: 'center' }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Search Patient"
                            value={searched}
                            onChange={(searchVal) => requestSearch(searchVal)}
                             inputProps={{ 'aria-label': 'search Patient' }}
                        />
                        <IconButton type="submit" sx={{ p: '4px' }} aria-label="search">
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                </div>
            </div>

            <TableContainer sx={{ maxHeight: "70vh" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth, color: "#002E98", fontWeight:"400" }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody className="listicon">
                        {rows
                            .slice(page.page * page.rowsPerPage, page.page * page.rowsPerPage + page.rowsPerPage)
                            .map((row, index) => {
                                return (
 
                                    <TableRow hover role="checkbox" onClick={() => { handleClick(row); goto(row.name) }} tabIndex={-1} key={row.code}>
                                            {columns.map((column, index) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell className={index === 3 ? 'table-button' : ''} key={column.id} align={column.align}>
                                                        {column.format && typeof value === 'number'
                                                            ? column.format(value)
                                                            : (index === 3 ? <VisibilityIcon></VisibilityIcon> : value)
                                                        }
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    // </Link>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={page.rowsPerPage}
                page={page.page}
                onPageChange={handleChangePage}
                className="bg-gray-300"
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );

}

export default withRouter(PatientList);
